export const SocialReferralEvent = {
  SocialReferralPageView: 'social_referral_page_view',
  SocialReferralJoinClick: 'social_referral_join_click',
  SocialReferralEndPageView: 'social_referral_end_page_view',
} as const;

export interface SocialReferralEventDataType {
  [SocialReferralEvent.SocialReferralPageView]: { campaign_id: string };
  [SocialReferralEvent.SocialReferralJoinClick]: { campaign_id: string };
  [SocialReferralEvent.SocialReferralEndPageView]: { campaign_id: string };
}
